// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import actions from '../../../action-list';
import {getMethodOfContact} from '../../../shared/repositories';

export const readMethodOfContactOptions = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getMethodOfContact();

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_METHOD_OF_CONTACT_OPTIONS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/get-method-of-contact-options.js